export default function SearchLoading() {
  const cards = Array(10).fill(null);

  return (
    <div className="product-list-loading">
      <div className="product-list-skeleton-grid">
        {cards.map((_, index) => (
          <div key={index} className="product-list-skeleton-card">
            <div className="product-list-skeleton-card__image" />
            <div className="product-list-skeleton-card__code" />
            <div className="product-list-skeleton-card__brand" />
            <div className="product-list-skeleton-card__name" />
          </div>
        ))}
      </div>
    </div>
  );
}
